import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { PromocionesService } from '../../services/promociones.service';

@Component({
  selector: 'app-promo-grupo-cliente-form',
  templateUrl: './promo-grupo-cliente-form.component.html',
  styleUrls: ['./promo-grupo-cliente-form.component.css']
})
export class PromoGrupoClienteFormComponent implements OnInit {

  agregarFormCondGrupoCliente!: FormGroup;
  _cmbGrupoCliente = [];

  @Input()
  set idPromo(id: string) {
    this.agregarFormCondGrupoCliente.get('id_promo').setValue(id);
  }

  @Input()
  groups = [];

  @Output()
  back = new EventEmitter<void>();

  @Output()
  create = new EventEmitter<any>();

  get cmbGrupoCliente() {
    return this._cmbGrupoCliente.filter((item) => !this.groups.some((_group) => _group.id_grupo_cliente === item.idGrupoCliente))
  }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly promocionesService: PromocionesService
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    this.cargarCondGrupoCliente();
  }

  private buildForm() {
    this.agregarFormCondGrupoCliente = this.formBuilder.group({
      id_promo: ['', []],
      id_grupo_cliente: ['', [Validators.required]]
    })
  }

  cargarCondGrupoCliente() {
    this.promocionesService.grupoCliente().subscribe(
      (resp) => {
        if (resp) {
          this._cmbGrupoCliente = resp;
        } else {
          this._cmbGrupoCliente = [];
        }
      },
      (error) => {
        this._cmbGrupoCliente = [];
      }
    );
  }

  accionesCondGrupoCliente(event: string) {
    if (event === 'guardar') {
      this.create.emit(this.agregarFormCondGrupoCliente.getRawValue());
    } else {
      this.back.emit();
    }
  }

}
